import { useCallback } from 'react';
import { usePane, useWorkspace } from './workspaceContext';

/** Модификаторы клика, которые меняют, где открыть объект. */
interface OpenGesture {
  shiftKey?: boolean;
  ctrlKey?: boolean;
  metaKey?: boolean;
  button?: number;
}

/**
 * Открыть объект так, как привыкли в браузере: клик — во вкладке этого окна, Ctrl/⌘ или средняя
 * кнопка — во вкладке на фоне, Shift — рядом, во втором окне.
 */
export function useObjectOpen() {
  const { go, openBeside } = useWorkspace();
  const pane = usePane();
  return useCallback(
    (path: string, e?: OpenGesture) => {
      if (e?.shiftKey) openBeside(path, pane);
      else if (e?.ctrlKey || e?.metaKey || e?.button === 1) go(path, { pane, background: true });
      else go(path, { pane });
    },
    [go, openBeside, pane],
  );
}
